import { GeckoColorScale } from 'color-scale-kit'
import React, { FC } from 'react'
import {
  DataType,
  GeckoColorScaleThreshold,
  GeckoComponentDataFrame,
  GeckoComponentDefaults,
  GeckoMeasurementRange,
} from 'types'

import { CategorySelector } from './categoryFilter/CategorySelector'
import { RangeSelector } from './rangeFilter/RangeSelector'

/**
 * A component that will display the correct filter input based on the data type of the provided CDF (categorical vs. quantitative)
 */
export const DataFilterInput: FC<{
  selectedCDF: GeckoComponentDataFrame
  selectedColorScale: GeckoColorScale
  selectedColorThreshold: GeckoColorScaleThreshold
  selectedComponentDefaults: GeckoComponentDefaults | undefined
  filteredValueRange: GeckoMeasurementRange | undefined
  onFilteredValueRangeChange: (range: GeckoMeasurementRange | undefined) => void
  onCategoricalValuesSelected: (values: number[] | undefined) => void
  forceRefreshComponentDefaultsFetch: () => void
}> = ({
  selectedCDF,
  selectedColorScale,
  selectedColorThreshold,
  selectedComponentDefaults,
  filteredValueRange,
  onFilteredValueRangeChange,
  onCategoricalValuesSelected,
  forceRefreshComponentDefaultsFetch,
}) => {
  const measurementUnit = selectedCDF.data.params.measurement_unit
  if (measurementUnit.dataType === DataType.Categorical) {
    return (
      <CategorySelector
        selectedCDF={selectedCDF}
        selectedColorScale={selectedColorScale}
        onFilteredValueRangeChange={onFilteredValueRangeChange}
        onCategoricalValuesSelected={onCategoricalValuesSelected}
      />
    )
  }

  return (
    <RangeSelector
      selectedCDF={selectedCDF}
      selectedColorScale={selectedColorScale}
      filteredValueRange={filteredValueRange}
      onFilteredValueRangeChange={onFilteredValueRangeChange}
      selectedComponentDefaults={selectedComponentDefaults}
      forceRefreshComponentDefaultsFetch={forceRefreshComponentDefaultsFetch}
      selectedColorThreshold={selectedColorThreshold}
    />
  )
}
